import { BASE_ASSET_URL } from 'flows/common/constants'
import { defineSteps, step } from 'flows/common/helpers/defineSteps'
import MarketingExperience from 'flows/common/steps/MarketingExperience/MarketingExperience'
import { StepDefinition } from 'flows/common/types'

export const onboardingSteps: StepDefinition[] = defineSteps([
  step('marketingExperience', MarketingExperience).withImage(`${BASE_ASSET_URL}/6.jpeg`),
])
